import React from 'react'
import ReactDOM from 'react-dom/client'
import AdPortalApp from './AdPortalApp'
import '../index.css'

// Cross-origin auth handoff: the main renter app runs on a different origin,
// so its localStorage JWT can't reach this bundle directly. The "Talk to an
// Attorney" link appends ?token=...&document_id=... on first navigation here;
// capture it into this origin's own storage (same key api.js already reads),
// then strip it from the URL so it doesn't linger in history/referrers.
const params = new URLSearchParams(window.location.search)
const token = params.get('token')
if (token) {
  localStorage.setItem('auth_token', token)
  params.delete('token')
  const rest = params.toString()
  window.history.replaceState({}, '', window.location.pathname + (rest ? `?${rest}` : ''))
}

ReactDOM.createRoot(document.getElementById('root')).render(
  <React.StrictMode>
    <AdPortalApp />
  </React.StrictMode>,
)
